import { PageContainer } from '../../../shared/PageContainer';
import { PageDefaultSegment, SwitchInput, TextInput, DateInput, TimeInput } from "@sis/react-library"
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { useState } from 'react';
import { Grid } from '@mui/material';
import { FormSamplesControlsNotUsingFormPageInfo } from './FormSamplesControlsNotUsingFormPageInfo';

///////////////////////////////////////////////////////////////////////////////////////////////////////
// You can use any controls outside a form component if you wish to keep the look and feel consistent.
// For example you might want a search box which you dont need a form for.
// You just need to cater for the label, value and onChange yourself.
// You can also utilize other props like showError and errorMessage
//////////////////////////////////////////////////////////////////////////////////////////////////////

export const FormSamplesControlsNotUsingFormPage = () => {

  const [textInputValue, setTextInputValue] = useState("");
  const [switchInputValue, setSwitchInputValue] = useState(false);
  const [dateInputValue, setDateInputValue] = useState("");
  const [timeInputValue, setTimeInputValue] = useState("");

  const handleTextInputOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('text=', e.target.value);
    setTextInputValue(e.target.value);
  }

  const handleSwitchInputOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('switch=', e.target.value);
    const boolValue = Boolean(e.target.value);
    setSwitchInputValue(boolValue);
  }

  const handleDateInputOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('date=', e.target.value);
    setDateInputValue(e.target.value);
  }

  const handleTimeInputOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('time=', e.target.value);
    setTimeInputValue(e.target.value);
  }

  return (
    <PageContainer
      heading='Form Samples - Controls Not Using Form'
      icon={<TextSnippetIcon />}
      pageInfo={<FormSamplesControlsNotUsingFormPageInfo />}
    >
      <PageDefaultSegment width={400}>
        <Grid container spacing={2}>
          <Grid size={{ md: 12 }}>
            <TextInput
              id="textinput"
              label="Example textbox"
              value={textInputValue}
              onChange={handleTextInputOnChange}
            ///////////////////////////////////////////////////////////////////
            // You can utilize other props like showError and errorMessage
            ///////////////////////////////////////////////////////////////////
            //showError
            //errorMessage='Not valid'
            />
          </Grid>
          <Grid size={{ md: 12 }}>
            <SwitchInput
              id="switchinput"
              label="Example switch"
              value={switchInputValue}
              onChange={handleSwitchInputOnChange}
            ///////////////////////////////////////////////////////////////////
            // You can utilize other props like showError and errorMessage
            ///////////////////////////////////////////////////////////////////
            //showError
            //errorMessage='Not valid'
            />
          </Grid>
          <Grid size={{ md: 12 }}>
            <DateInput
              id="dateinput"
              label="Example date"
              value={dateInputValue}
              onChange={handleDateInputOnChange}
            />
          </Grid>
          <Grid size={{ md: 12 }}>
            <TimeInput
              id="timeinput"
              label="Example time"
              value={timeInputValue}
              onChange={handleTimeInputOnChange}
            />
          </Grid>
        </Grid>
      </PageDefaultSegment>
    </PageContainer>
  )
}
